import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import LeftMenu from 'components/LeftMenu';
import Footer from 'components/Footer';
import ImpersonateBar from 'components/ImpersonateBar';
import { WEBIEW_MESSAGE } from 'constants/webview';
import { sendMessageToWebview } from 'utils/sendMessageToWebview';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import './styles.scss';

function MainLayout({ route, children }) {
  const literalsCommon = useSelector(state => state.i18n.literals.common);
  const user = useSelector(state => state.session.user);
  const platform = useSelector(state => state.global.platform);

  const mainComponentRef = useRef(null);
  const location = useLocation();
  const isEmbed = useMemo(() => route?.path?.startsWith('/embed'), [route?.path]);

  useEffect(() => {
    if (mainComponentRef.current) {
      mainComponentRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [location]);

  useEffect(() => {
    if (!mainComponentRef.current || !isEmbed) return;

    const checkSize = () => {
      const { scrollWidth: width, scrollHeight: height } = mainComponentRef.current;
      sendMessageToWebview(WEBIEW_MESSAGE.SET_EMBED, { width, height });
    };

    const observer = new MutationObserver(checkSize);
    if (mainComponentRef.current) {
      observer.observe(mainComponentRef.current, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      checkSize();
    }

    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, [isEmbed, route?.path]);

  return (
    <div className='layout-container--top'>
      {user.impersonate && <ImpersonateBar literalsCommon={literalsCommon} user={user} />}

      <div className={`layout-container--left ${isEmbed ? 'embed' : ''}`}>
        {route.aside && <LeftMenu platform={platform} route={route} />}
        <main className={route.className} ref={mainComponentRef}>
          <div className='main-component'>
            {children}
          </div>
          {!isEmbed && <Footer />}
        </main>
      </div>
    </div>
  );
}

MainLayout.propTypes = {
  route: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default MainLayout;
